  <template>
  <b-modal style="padding:15px" size="lg" id="AddUserModal" ref="modal" title="Add User" ok-title="Submit" cancel-title="Close" 
      @show= "setData()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddUserForm != undefined ? !this.$refs.AddUserForm.checkValidity() : true">
        <form ref="AddUserForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-4">
              <!--NAME INPUT-->
              <b-form-group :state="userNameState" label="User Name" label-for="username-input" :invalid-feedback="usernameInvalidFeedback" autocomplete="off">
                <b-form-input id="username-input" v-model= "UserName" :state="userNameState" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="First Name" label-for="firstName-input" autocomplete="off">
                <b-form-input id="firstName-input" v-model= "FirstName"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group  label="Last Name" label-for="lastName-input" autocomplete="off">
                <b-form-input id="lastName-input" v-model= "LastName"  required></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
               <b-form-group :state="emailState" label="Email" label-for="email-input" :invalid-feedback="emailInvalidFeedback" autocomplete="off">
                <b-form-input id="email-input" v-model= "Email" :state="emailState" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group :state="passwordState" label="Password" label-for="password-input" :invalid-feedback="passwordInvalidFeedback" autocomplete="off">
                <b-form-input id="password-input" v-model= "Password" :state="passwordState" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group :state="confirmPasswordState" label="Confirm Password" label-for="cpasssword-input" :invalid-feedback="confirmPasswordInvalidFeedback" autocomplete="off">
                <b-form-input id="cpassword-input" v-model= "ConfirmPassword" :state="confirmPasswordState" required></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class = "row">
            <div class="col-md-4">
              <b-form-group :state="phoneNumberState" label="Phone" label-for="phone-input" :invalid-feedback="phoneInvalidFeedback" autocomplete="off">
                <b-form-input id="phone-input" v-model= "PhoneNumber" :state="phoneNumberState" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4" v-if= "$auth.user().companyId== null">
              <b-form-group label="Company" label-for="company-input"  autocomplete="off">
                <!-- <b-form-input id="role-input" v-model= "Role" :state="roleState" required></b-form-input> -->
                <b-form-select id="company-input" value-field="id" text-field="companyName" v-model= "Company" :options="companies" @change="getCompanyRoles()" required>
                  <b-form-select-option :value = null disabled hidden>Select Company</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Role" label-for="role-input" autocomplete="off">
                <b-form-select id="role-input" v-model= "Role" value-field="id" text-field="name" :options="roles" required>
                  <b-form-select-option :value = null disabled hidden>Select Role</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>
           
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'Users',
    data(){
        return{
          moduleName:'Users',
          Company:null,
          UserName:'',
          FirstName:'',
          LastName:'',
          Email:'',
          Password:'',
          ConfirmPassword:'',
          PhoneNumber:'',
          Role:null,
          companies:[],
          roles: [],
       
		}
  },
  mounted()
  {
    axios.post('/company/getall', 
      {"UserId":this.$auth.user().id,"IsActive":true})
      .then(res=>{
            if(res.data.status == 1)
            {
              this.companies = res.data.data;
              console.log(res)
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
  computed:{
   
    userNameState()
    {   
     return this.UserName.length >= 4
    },
    usernameInvalidFeedback(){
      return 'username must contains 4 or more characters';
      },
    emailState()
    {
      const re = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
      return re.test(String(this.Email).toLowerCase());
    },
    emailInvalidFeedback()
    {
      return 'invalid email address';
    },
    passwordState()
    {
      return this.Password.length >=5;
    },
    passwordInvalidFeedback()
    {
      return 'password should contains 5 or more characters'
    },
    confirmPasswordState()
    {
      return this.Password == this.ConfirmPassword;
    },
    confirmPasswordInvalidFeedback()
    {
      return 'password mismatch';
    },
    phoneNumberState()
    {
      const re  = /^[\d]{11}$/;
      return re.test(this.PhoneNumber);
      
    },
    phoneInvalidFeedback()
    {
      return 'phone number should be 11 digits long';
    },
    
   
  },

methods:{
  setData()
  {
    let currentUser = this.$auth.user();
    if(currentUser.companyId == null && currentUser.userName == "SuperAdmin")
    {
      this.company = null;
    }
    else
    {
      this.Company = currentUser.companyId;
      this.getCompanyRoles();
    }
  },
    getCompanyRoles()
    {
      this.Role = null;
      axios.post('/role/getall', 
      {"CompanyId":this.Company})
      .then(res=>{
            if(res.data.status == 1)
            {
              this.roles = res.data.data;
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
    addUser(){ 
       
     axios.post('/user/Add', 
      {"UserName":this.UserName,"FirstName":this.FirstName, "LastName":this.LastName, "Email":this.Email,
      "Password":this.Password,"PhoneNumber":this.PhoneNumber,"Role":this.Role,"CompanyId":this.Company
      },{headers: {'Content-Type': 'application/json'}})
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('User added successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go()
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
   checkFormValidity() {
        const valid = this.$refs.AddUserForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.UserName='';
        this.FirstName = '';
        this.LastName = '';
        this.Email = '';
        this.Password = '';
        this.ConfirmPassword ='',
        this.PhoneNumber = '',
        this.Role = null
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        console.log(this.Role)
        console.log(this.Company)
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addUser()
        
        this.$nextTick(() => {
          //this.$router.go('/phones')
          this.$bvModal.hide('AddUserModal')
        
        })
      },
 
  
  },
}
</script>
